import axios, { AxiosError } from "axios";
import { isAllAccessApiError } from "./maintenanceInterceptor";

const RENEWAL_STARTED_AT_KEY = "sessionRenewalStartedAt";
const RENEWAL_COOLDOWN_MS = 2 * 60 * 1000;

const handled = new WeakSet<object>();
let isRenewing = false;

const wasRenewedRecently = (): boolean => {
    const startedAt = Number(sessionStorage.getItem(RENEWAL_STARTED_AT_KEY));

    return startedAt > 0 && Date.now() - startedAt < RENEWAL_COOLDOWN_MS;
};

export const isSessionExpiredError = (error: unknown): boolean =>
    typeof error === "object" && error !== null && handled.has(error);

export const installSessionExpiredInterceptor = (renewSession: () => Promise<void>): (() => void) => {
    const interceptorId = axios.interceptors.response.use(
        (response) => response,
        (error: AxiosError) => {
            const isRejectedToken = isAllAccessApiError(error) && error.response?.status === 401;

            if (!isRejectedToken || (!isRenewing && wasRenewedRecently())) {
                return Promise.reject(error);
            }

            handled.add(error);

            if (!isRenewing) {
                isRenewing = true;
                sessionStorage.setItem(RENEWAL_STARTED_AT_KEY, Date.now().toString());
                renewSession().catch(() => {
                    isRenewing = false;
                });
            }

            return Promise.reject(error);
        }
    );

    return () => axios.interceptors.response.eject(interceptorId);
};
